// extracted by css-extract-rspack-plugin
export default {"cls1":"CitationModal-cls1_DuG","cls2":"CitationModal-cls2_KBe CitationModal-cls1_DuG"};